export type ProgressAnswers = Record<string, number | string | string[] | null>;

export const progressAnswerCount = (answers: ProgressAnswers) => Object.values(answers).filter(value =>
  typeof value === 'number' || (typeof value === 'string' && value.trim().length > 0)
  || (Array.isArray(value) && value.length > 0)).length;

export async function progressDigest(answers: ProgressAnswers): Promise<string> {
  const canonical = JSON.stringify(Object.keys(answers).sort((a, b) => Number(a) - Number(b)).map(key => [key, answers[key]]));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonical));
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}

export interface ProgressConfirmation {
  success: boolean;
  test_session_id: string;
  saved_answer_count: number;
  answer_digest: string;
  revision: number;
  save_id: string;
  question_ids: string[];
  progress: { index: number; answers: ProgressAnswers; revision?: number };
}

// Count alone cannot detect a wrong answer or a missing writing field. Verify
// every value from the requested snapshot against an independent cloud read.
export async function verifyProgressConfirmation(
  confirmation: ProgressConfirmation, testId: string, saveId: string, requested: ProgressAnswers, questionIds: string[],
) {
  if (!confirmation?.success || confirmation.test_session_id !== testId || confirmation.save_id !== saveId
    || !confirmation.progress?.answers || !Number.isInteger(confirmation.revision)
    || JSON.stringify(confirmation.question_ids) !== JSON.stringify(questionIds)) {
    throw new Error('云端未确认本次保存，已保留本机答案，请重试。');
  }
  const stored = confirmation.progress.answers;
  if (confirmation.answer_digest !== await progressDigest(stored)
    || confirmation.saved_answer_count !== progressAnswerCount(stored)
    || Object.entries(requested).some(([key, value]) => JSON.stringify(stored[key]) !== JSON.stringify(value))) {
    throw new Error('云端答案核对不一致，已保留本机答案，请重试保存。');
  }
  return confirmation.saved_answer_count;
}
